import {
	deliveryLocatorHeaderContainerSX,
	deliveryLocatorHeaderInfoSX,
	deliveryLocatorHeaderInfoTextSX,
	deliveryLocatorHeaderInfoZipCodeSX,
} from '@/components/content/Header/parts/DeliveryLocator/styles/DeliveryLocatorHeaderInfo/deliveryLocatorHeaderInfoStyles';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { useLocalization } from '@/data/Localization';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { MATERIAL_SYMBOL_ICONS } from 'shared/custom/constants/commonConstants';

export const DeliveryLocatorHeaderInfo: FC<{
	isLocatorOptionSelected: boolean;
	zipCode: string;
}> = ({ isLocatorOptionSelected, zipCode }) => {
	const theme = useTheme();
	const localization = useLocalization('DeliveryLocator');

	return (
		<Stack sx={deliveryLocatorHeaderInfoSX(theme, isLocatorOptionSelected)}>
			<Typography variant="bodySubText" sx={deliveryLocatorHeaderInfoTextSX} id="locationLegend">
				{localization.locationLegend.t()}
			</Typography>
			<Box sx={deliveryLocatorHeaderContainerSX}>
				<DynamicIcon
					variant={isLocatorOptionSelected ? 'filled' : 'rounded'}
					name={MATERIAL_SYMBOL_ICONS.locationOn}
					size={16}
					color={isLocatorOptionSelected ? theme.palette.primary.main : theme.palette.grey[500]}
				/>
				<Typography variant="body1" sx={deliveryLocatorHeaderInfoZipCodeSX} id="locationZipCode">
					{zipCode}
				</Typography>
			</Box>
		</Stack>
	);
};
